import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { norristownConfig } from "./data";

export default function NorristownPage() {
  return <CityPageTemplate config={norristownConfig} />;
}